const Client = require("../modules/ModHttpsClient")

// Store for the redirect parameter
let redirectUrl = null;


module.exports = {
    load(url){
        return Client.get([
            {
                key: "url",
                value: encodeURIComponent(url)
            }
        ],{
            path: "/client/config/load"
        })
    },

    // Reads the "redirect" and "id" parameters from process.argv and stores them
    readRedirectParam(specsObj) {
        if (typeof window !== "undefined" && window.location && window.location.search) {
            const params = new URLSearchParams(window.location.search);

            // Read "redirect" parameter
            if (params.has("redirect")) {
                redirectUrl = params.get("redirect");
            } else {
                redirectUrl = null;
            }

            // Read "id" parameter and set to ModParticipant.data.tan.id
            if (params.has("id")) {
                try {
                    const ModParticipant = require("./ModParticipant");
                    if (!ModParticipant.data) ModParticipant.data = {};
                    if (!ModParticipant.data.tan) ModParticipant.data.tan = {};
                    ModParticipant.data.tan.id = params.get("id");
                    //ModParticipant.data.lang = params.get("lang") || null;
                } catch (e) {
                    // Handle error if ModParticipant is not available
                }
            }

            // Extract "aid" (Integer) and "pid" (String) and set to specsObj if provided
            if (specsObj) {
                if (params.has("aid")) {
                    const aidValue = parseInt(params.get("aid"), 10);
                    if (!isNaN(aidValue)) {
                        specsObj.accountId = aidValue;
                    }
                }
                if (params.has("pid")) {
                    specsObj.projectId = params.get("pid");
                }

                // Alle übrigen Parameter sammeln
                specsObj.queries = specsObj.queries || {};
                for (const [key, value] of params.entries()) {
                    if (
                        key !== "redirect" &&
                        key !== "id" &&
                        key !== "aid" &&
                        key !== "pid" //&&
                        //key !== "lang"
                    ) {
                        specsObj.queries[key] = value;
                    }
                }
            }
        }
    },
    // Getter for the stored redirect URL
    getRedirectUrl() {
        return redirectUrl;
    }
}